import { Injectable } from '@angular/core';
import { EntityService } from '../../../../rest/entity.service';
import { JQueryHTTPClient } from '../../../../rest/JQueryHTTPClient';
import { Rest_task } from './rest_client_task';
import { Rest } from '../../../../rest/rest_client';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { AuthenticationService } from '../../../../core/services/authentication/authentication.service';
import { NotificationsService, Severity } from '../../../../services/notifications-service/notifications.service';

@Injectable()
export class RoutesService extends EntityService<Rest_task.Route> {
	client: Rest.RestApplicationClient;

	constructor(
		private jquery: JQueryHTTPClient,
		private http: HttpClient,
		private auth: AuthenticationService,
		private notificationsService: NotificationsService
	) {
		super();
		this.client_task = new Rest_task.RestApplicationClient(jquery);
	}
	/*
    create(arg0: Rest_task.Route): Rest.RestResponse<Rest_task.Route> {
      //  return this.client_task.Route_create(arg0);
      return null;
    }*/
	/*
   update(arg0: Rest_task.Route): Rest.RestResponse<Rest_task.Route> {
       return this.client_task.Route_update(arg0);
      // return null;
   } */

	createWithGenericResponse(arg0: Rest_task.Route): Rest.RestResponse<Rest.GenericResp<Rest_task.Route>> {
		return this.client_task.Route_create(arg0);
	}

	updateWithGenericResponse(arg0: Rest_task.Route): Rest.RestResponse<Rest.GenericResp<Rest_task.Route>> {
		return this.client_task.Route_update(arg0);
	}
	delete(arg0: Rest_task.Route[]): Rest.RestResponse<void> {
		return this.client_task.Route_delete(arg0[0]);
	}

	find(arg0: string, queryParams?: { id?: number }): Rest.RestResponse<Rest_task.Route> {
		return this.client_task.Route_find(arg0, queryParams);
	}

	getPage(arg0: Rest.ListPaginationRequest): Rest.RestResponse<Rest.Page<Rest_task.Route>> {
		return this.client_task.Route_getPage(arg0);
	}

	getPageAndFilters(arg0: Rest.ListPaginationRequest): Rest.RestResponse<Rest.ListPageAndFilters<Rest_task.Route>> {
		return this.client_task.Route_getPageAndFilters(arg0);
	}

	getPageRouteTypes(arg0: Rest.ListPaginationRequest): Rest.RestResponse<Rest.Page<Rest_task.RouteType>> {
		return this.client_task.RouteType_getPage(arg0);
	}

	getRouteTypesByUserClient(): Rest.RestResponse<Rest_task.RouteType[]> {
		return this.client_task.RouteType_findByUserClient();
	}

	changeStatus(arg0: number[], queryParams?: { status?: boolean }): Rest.RestResponse<void> {
		return this.client_task.Route_changeStatus(arg0, queryParams);
	}

	validateRoute(arg0: any):  Rest.RestResponse<Rest.GenericResp> {
		return this.client_task.Route_validate(arg0);
	}
}
